/**
 * Debounce function
 * @param {Function} fn
 * @param {Number} wait
 */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

export { debounce as d };
